// Operation RIVERGHOST — boot + route table.

import "./styles/system.css";
import "./lib/install"; // register beforeinstallprompt listener ASAP
import { onAuth } from "./lib/firebase";
import { startRouter, route, setNotFound } from "./router";
import { el, mount } from "./lib/dom";

// Guest screens
import { renderActivation } from "./screens/activation";
import { renderBriefing, wasBriefed } from "./screens/briefing";
import { renderMap } from "./screens/map";
import { renderCases } from "./screens/cases";
import { renderLeaderboard } from "./screens/leaderboard";
import { renderGallery } from "./screens/gallery";
import { renderProfile } from "./screens/profile";
// Admin
import { renderAdmin } from "./admin/dashboard";

route("/activate", renderActivation, { auth: false });
route("/briefing", renderBriefing);
route("/map", renderMap);
route("/cases", renderCases);
route("/leaderboard", renderLeaderboard);
route("/gallery", renderGallery);
route("/profile", renderProfile);
// Old deep links now fold into the tactical map (home): the storyline,
// caches, radar and mole screens are gone.
route("/hq", () => { location.hash = "/map"; });
route("/chapter/:id", () => { location.hash = "/map"; });
route("/mole", () => { location.hash = "/map"; });
route("/caches", () => { location.hash = "/map"; });
route("/radar", () => { location.hash = "/map"; });
route("/admin", renderAdmin, { auth: false }); // gate handled inside (Google sign-in)

setNotFound(() => mount(el("div.card", {}, el("h2", {}, "404 — SIGNAL LOST"))));

// Start the router once auth state first resolves; redirect sensibly.
let booted = false;
onAuth((user) => {
  if (user) void import("./lib/push").then((m) => m.initForegroundMessages());
  if (!booted) {
    booted = true;
    const path = location.hash.slice(1);
    if (user && (!path || path === "/activate")) {
      location.hash = wasBriefed() ? "/map" : "/briefing";
    }
    // Not signed in: send to the login screen unless deep-linking to the
    // self-gated admin console. This also covers the bare root URL (no hash).
    else if (!user && path !== "/activate" && path !== "/admin") location.hash = "/activate";
    startRouter();
    return;
  }
  // Later changes (e.g. sign-out) bounce to activation. A full reload tears
  // down every live Firestore listener, which would otherwise keep firing
  // permission-denied errors against the signed-out session.
  if (!user) {
    location.replace(`${location.pathname}#/activate`);
    location.reload();
  }
});
